import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContainedButton } from '@guryou/html-components';
import Papa from 'papaparse';

const ExportCSV = ({ data, filename = 'data.csv' }) => {
  const { t } = useTranslation();
  const handleExport = () => {
    let url;
    try {
      const headers = [
        t('GENERAL.clientName'),
        t('GENERAL.email'),
        t('SECTION_VIDEOS.sectionName'),
        t('SECTION_VIDEOS.watched'),
        t('SECTION_VIDEOS.total'),
        t('SECTION_VIDEOS.percentage'),
      ];
      const csv = Papa.unparse({
        fields: headers,
        data: data?.map(x => [x.name, x.email, x.sectionName, x.watched, x.total, x.percentage]),
      });
      const blob = new Blob([csv], { type: 'text/csv' });
      url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('download', filename);
      a.click();
    } catch (err) {
      //eslint-disable-next-line
      console.log('Error exporting to CSV: ', err);
    } finally {
      if (url) {
        URL.revokeObjectURL(url);
      }
    }
  };

  return <ContainedButton onClick={handleExport}>{t('SECTION_VIDEOS.export')}</ContainedButton>;
};

export default ExportCSV;
